import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://6597b9e834abcc71fe5489fdca949151@o4510037429125120.ingest.de.sentry.io/4510037430632528",
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/astro/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
  enabled: process.env.NODE_ENV !== "development",
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Silently handle transport failures (e.g. ad blockers blocking Sentry requests)
  transportOptions: {
    fetchOptions: {
      keepalive: true,
    },
  },
  ignoreErrors: [
    // User-initiated request aborts (e.g. navigating away while a fetch is in progress)
    "AbortError",
    "The user aborted a request",
    "signal is aborted without reason",
    // Transient network failures
    "Failed to fetch",
    "NetworkError",
    "Load failed",
    // Firebase Auth internal race conditions
    "INTERNAL ASSERTION FAILED",
    "Pending promise was never set",
    // View Transitions API aborts
    "Transition was aborted",
    "View transition was skipped",
    // Browser/environment errors (not actionable)
    "Connection to Indexed Database server lost",
    "reCAPTCHA",
    "Failed to fetch dynamically imported module",
    "Hydration",
    // Expected auth redirects and user-facing auth errors
    "error.user_must_logging_in",
    "Missing or insufficient permissions",
    // Firebase auth expected user errors
    "auth/code-expired",
    // Third-party payment script loading failures (CDN / network)
    "Failed to load Stripe.js",
    // Non-Error promise rejections
    "Non-Error promise rejection captured",
    // Third-party / browser extension errors (e.g. JSON-LD parsers)
    /@context/,
    // React server hydration errors
    "This root received an early update, before anything was able hydrate. Switched the entire root to client rendering",
    "Error: This root received an early update, before anything was able hydrate",
    // Firebase Auth GAPI iframe race condition
    /Cannot read properties of undefined \(reading 'getContext'\)/,
    // Firebase RTDB permission errors during member registration race
    "PERMISSION_DENIED",
    // Android WebView internal errors
    "Java object is gone",
    // React DOM reconciliation with view transitions / browser extensions
    /removeChild/,
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enableLogs: true,
  tracesSampleRate: 1.0,
});
